import React from 'react';
import { IconProps } from '../../../types/header.types';
import chevronDownIcon from '../../../../assets/01d8de6444f9710c72cd82882ec2a02e4200ce89.svg';

const ChevronDownIcon: React.FC<IconProps> = ({
  size = 20,
  color = '#252b37',
  className = ''
}) => {
  return (
    <div
      className={`chevron-down-icon ${className}`}
      style={{
        width: size,
        height: 28,
        '--icon-color': color
      } as React.CSSProperties}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={12}
        height={7}
        viewBox="0 0 12 7"
        fill="none"
      >
        <path
          d="M11 1.33203L6.58926 5.74278C6.26382 6.06821 5.73618 6.06821 5.41074 5.74278L1 1.33203"
          stroke="#252B37"
          strokeWidth="1.67"
          strokeLinecap="round"
        />
      </svg>

    </div>
  );
};

export default ChevronDownIcon;
